import type { IndexedStorySection } from '@prezly/theme-kit-core';
import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';
import type { StateResultsProvided } from 'react-instantsearch-core';
import { connectStateResults } from 'react-instantsearch-dom';

const SearchStateContext = createContext<StateResultsProvided<IndexedStorySection> | undefined>(
    undefined,
);

// InstantSearch connect API is pretty broken, so this is a workaround to provide some search state to components lower in the tree
function SearchStateContextProvider({
    children,
    ...contextValue
}: PropsWithChildren<StateResultsProvided<IndexedStorySection>>) {
    return (
        <SearchStateContext.Provider value={contextValue}>{children}</SearchStateContext.Provider>
    );
}

export default connectStateResults(SearchStateContextProvider);

export function useSearchState() {
    const state = useContext(SearchStateContext);

    if (!state) {
        throw new Error('`useSearchState` should only be used inside `SearchStateContextProvider`');
    }

    return state;
}
